module.exports = __webpack_public_path__ + "static/media/campaigns.fed77512.svg";